/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */

import React, { useContext, useEffect, useState } from "react";
import { Content } from "./styles";
import { Col, Row } from "components/Grid";
import { NotesAccordion } from "components";
import { GlobalAuthContext } from "store/context";
import EnquiryCard, { EnquiryCardContainer } from 'components/EnquiryCard'
import { FitinsurAPI } from 'utils';
import { Mask } from 'utils';
import { useGetOperation } from 'services/OperationService';
import Loading from "./loading";
import moment from 'moment';
import {
  useGetQuestionnaireAnswerAsync
} from '@fitinsur/services/QuestionnaireAnswerService';
const momentTz = require('moment-timezone');


export default function BrokingSummary({ idOperation, idPaymentOperation, history, permissions }) {
  const authContext = useContext(GlobalAuthContext);
  const isClient = authContext.enumProfile === 1 ? true : false;
  const fitinsur = new FitinsurAPI();
  const [isLoading, setIsLoading] = useState(false);
  const [persons, setPersons] = useState([]);
  const [maxClaim, setMaxClaim] = useState({ dsQuestion: 'IMPORTÂNCIA SEGURADA/LIMITE', answer: '-' });
  const [ramo, setRamo] = useState({ dsQuestion: 'RAMO', answer: '-' });
  const [idProduct, setIdProduct] = useState(null);
  const [operation, setOperation] = useState({});

  const {
    data: useGetOperationData,
    loading: useGetOperationLoading,
    error: useGetOperationError,
    status: useGetOperationStatus,
    request: useGetOperationRequest
  } = useGetOperation(idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswerAsync(idOperation);


  const handleGetQuote = async () => {
    if (!idProduct) return;
    fitinsur.setAuthToken(authContext.token);
    await useGetQuestionnairesAnswersRequest().then(({data}) => {
        let filteredPersons = [];
        let filteredOperations = [];
        let filteredRisks = [];
        if (idProduct === 55 || idProduct === 56 || idProduct === 9004) {
          filteredPersons = data.value.persons.filter(question => (
            (
              question.idQuestion === 1518 || //CNPJ DO TOMADOR
              question.idQuestion === 3372 || //CNPJ DO SEGURADO
              question.idQuestion === 3386 //CORRETOR
            ) && (question.answer || question.idAnswerOption)
          ))
            .map((person) => {
              if (person.idQuestion === 3372) {
                return {
                  ...person,
                  answer: Mask.cpfCnpj(person.answer)
                };
              }

              const answerObject = JSON.parse(person?.answer);
              const numericValue = String(answerObject.value);

              if (person.idQuestion === 1518) {
                return {
                  ...person,
                  answer: Mask.cpfCnpj(numericValue)
                };
              }

              if (person.idQuestion === 3386) {
                return {
                  ...person,
                  answer: numericValue
                };
              }
            });
        }

        if (idProduct === 57) {
          filteredPersons = [
            {
              dsQuestion: 'CPF/ CNPJ DO SEGURADO / RECLAMANTE',
              idQuestion: 0,
              answer: '-'
            },
            {
              dsQuestion: 'MODALIDADE',
              idQuestion: 1,
              answer: '-'
            }
          ];

          data.value.persons.forEach((person) => {
            if (person.idQuestion === 1634) {
              filteredPersons.push({
                ...person,
                answer: Mask.cpfCnpj(person.answer)
              });
            }

            if (person.idQuestion === 1776) {
              const answerObject = JSON.parse(person?.answer);
              const answerValue = String(answerObject.value);

              filteredPersons.push({
                ...person,
                answer: answerValue
              });
            }
          });

          let allLimits = [];
          data.value.operations.filter((operation) => {
            if (operation.idQuestion === 1680) allLimits.push(operation);
          });

          if (allLimits.length) {
            const lastLimit = allLimits[allLimits.length - 1];
            setMaxClaim({
              dsQuestion: 'IMPORTÂNCIA SEGURADA/LIMITE',
              answer: lastLimit.answer ? Number(lastLimit.answer).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-'
            });
          }
        }

        filteredOperations = [];
        const [beginningDateQst] = data.value.operations.filter(qst => (
          (
            (idProduct === 55 || idProduct === 56 || idProduct === 9004) && qst.idQuestion === 3447 ||
            (idProduct === 57 && qst.idQuestion === 1685)
          ) && (qst.answer || qst.dsQuestion)
        )).sort((a, b) => b.idQuestionnaireAnswers - a.idQuestionnaireAnswers);

        const [endDateQst] = data.value.operations.filter(qst => (
          (
            (idProduct === 55 || idProduct === 56 || idProduct === 9004) && qst.idQuestion === 3448 ||
            (idProduct === 57 && qst.idQuestion === 1686)
          ) && (qst.answer || qst.dsQuestion)
        )).sort((a, b) => b.idQuestionnaireAnswers - a.idQuestionnaireAnswers);

        const beginningDateAnswer = beginningDateQst?.answer || beginningDateQst?.dsQuestion;
        const endDateAnswer = endDateQst?.answer || endDateQst?.dsQuestion;

        const differenceInDays = (date1, date2) => {
          const msPerDay = 1000 * 60 * 60 * 24;
          const timeDiff = date2.getTime() - date1.getTime();
          return timeDiff / msPerDay;
        };

        const diff = differenceInDays(new Date(beginningDateAnswer), new Date(endDateAnswer));

        if (!isFinite(diff) || !beginningDateAnswer || !endDateAnswer) {
          filteredOperations.push({
            dsQuestion: "VIGÊNCIA",
            answer: '-'
          });
        } else {
          const beginningDate = momentTz(beginningDateAnswer).tz("America/Sao_Paulo").format('DD/MM/YYYY');
          const endDate = momentTz(endDateAnswer).tz("America/Sao_Paulo").format('DD/MM/YYYY');

          filteredOperations.push({
            dsQuestion: "VIGÊNCIA",
            answer: `${beginningDate} - ${endDate} (${diff} dias)`
          });
        }

        // VIGÊNCIA ENDOSSO
        const [beginningDateEndorsementQst] = data.value.operations.filter(qst => (
          qst.idQuestion === 3495 && (qst.answer || qst.dsQuestion)
        )).sort((a, b) => b.idQuestionnaireAnswers - a.idQuestionnaireAnswers);

        const [endDateEndorsementQst] = data.value.operations.filter(qst => (
          qst.idQuestion === 3499 && (qst.answer || qst.dsQuestion)
        )).sort((a, b) => b.idQuestionnaireAnswers - a.idQuestionnaireAnswers);

        if (beginningDateEndorsementQst || endDateEndorsementQst) {
          const beginningDateEndorsementAnswer = beginningDateEndorsementQst?.answer || beginningDateEndorsementQst?.dsQuestion;
          const endDateEndorsementAnswer = endDateEndorsementQst?.answer || endDateEndorsementQst?.dsQuestion;

          const diffEndorsement = differenceInDays(new Date(beginningDateEndorsementAnswer), new Date(endDateEndorsementAnswer));

          if (!isFinite(diffEndorsement) || !beginningDateEndorsementAnswer || !endDateEndorsementAnswer) {
            filteredOperations.push({
              dsQuestion: "VIGÊNCIA ENDOSSO",
              answer: '-'
            });
          } else {
            const beginningDateEndorsement = momentTz(beginningDateEndorsementAnswer).tz("America/Sao_Paulo").format('DD/MM/YYYY');
            const endDateEndorsement = momentTz(endDateEndorsementAnswer).tz("America/Sao_Paulo").format('DD/MM/YYYY');

            filteredOperations.push({
              dsQuestion: "VIGÊNCIA ENDOSSO",
              answer: `${beginningDateEndorsement} - ${endDateEndorsement} (${diffEndorsement} dias)`
            });
          }
        }

        filteredRisks = data.value.risks.filter(question => (
          ([3403].includes(question.idQuestion)) //MODALIDADE
          && (question.answer || question.idAnswerOption)
        ))

        setPersons([...filteredPersons, ...filteredRisks, ...filteredOperations]);
      }).catch(err => {
        console.log(err)
      })
    setIsLoading(false);
  }

  const handleGetOperation = async () => {
    await fitinsur.setAuthToken(authContext.token);
    await fitinsur.requestOperationInfo(idOperation)
      .then((x) => x.json())
      .then((response) => {
        setRamo({
          dsQuestion: 'RAMO',
          answer: response.ramoNumber && response.ramoName
            ? `${response.ramoNumber} - ${response.ramoName}`
            : '-'
        });
        if (idProduct === 55 || idProduct === 56 || idProduct === 9004) {
          setMaxClaim({
            dsQuestion: 'IMPORTÂNCIA SEGURADA/LIMITE',
            answer: response.operationMaxLimClaim
              ? Number(response.operationMaxLimClaim).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              : '-'
          });
        }
      }).catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    if (!useGetOperationStatus) return;
    if (useGetOperationStatus === 200) {
      setIdProduct(useGetOperationData.value.idProduct);
      setOperation(useGetOperationData.value);
    }
  }, [useGetOperationStatus])

  useEffect(() => {
    async function start() {
      try {
        await handleGetOperation();
        await handleGetQuote();
      } catch (e) {
        console.log(e)
      }
    }
    if (idProduct) start();
  }, [idProduct])

  useEffect(() => {
    if (idOperation) {
      setIsLoading(true);
      useGetOperationRequest(idOperation);
    }
  }, [])

  if (!idOperation) {
    return (
      <Content>
        <Row style={{ flexDirection: 'column', height: 20 }}>
        </Row>
      </Content>
    )
  }

  return (
    <Content>
      {isLoading ? (
        <Loading idProduct={idProduct} />
      ) : (
        <Content>
          <Row style={{ flexDirection: 'column' }}>
            <EnquiryCardContainer>
              <Col xs={12} md={4} style={{ paddingLeft: 0, marginBottom: 10, paddingRight: '15px' }}>
                <EnquiryCard
                  person={{}}
                  idQuestion={1}
                  field={"NÚMERO"}
                  value={operation?.operationMetadata?.idQuotationOperation || idOperation} />
              </Col>

              <Col xs={12} md={4} style={{ paddingLeft: 0, marginBottom: 10, paddingRight: '15px' }}>
                <EnquiryCard
                  person={{}}
                  idQuestion={1}
                  field={ramo.dsQuestion}
                  value={ramo.answer} />
              </Col>

              {persons.map((person, index) => {
                console.log("personxxxxx", person)
                return (
                  <Col key={index} xs={12} md={4} style={{ paddingLeft: 0, marginBottom: 10, paddingRight: '15px' }}>
                    <EnquiryCard
                      person={person}
                      idQuestion={person.idQuestion}
                      field={person.dsQuestion}
                      value={person.answer} />
                  </Col>)
              })}

              <Col xs={12} md={4} style={{ paddingLeft: 0, marginBottom: 10, paddingRight: '15px' }}>
                <EnquiryCard
                  person={{}}
                  idQuestion={1}
                  field={maxClaim.dsQuestion}
                  value={maxClaim.answer} />
              </Col>

            </EnquiryCardContainer>
          </Row>
          <Row sm={12} md={12}>
            <NotesAccordion
              idQuestion={1573}
              history={history}
              title="Anotações"
              idOperation={idOperation}
              idPaymentOperation={idPaymentOperation ?? idOperation}
              permissions={!isClient && permissions?.VIEW_NOTES}
            />
          </Row>
        </Content>
      )}
    </Content>
  );
}
